<div class="col-12">
  <div class="col-12">
    <!-- メモボタン -->
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="parentOpenMemoModal">
      {{ $t('message.button_vehicle_dtc_note_modal') }}
    </b-button>
    <!-- ファイルエクスポートボタン -->
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="csvExport">
      {{ $t('message.file_export') }}
    </b-button>
  </div>
  <!-- データ表示テーブル -->
  <div class="col-12 ml-2 mt-2">
    <custom-table :items="cstmListItem" :columns="tableItems" class="text-nowrap" type="simple"
      rowSelect currentSortkey="dtc" initSortDir="asc" useStripeStyle hasTabs @rowButtonClicked="clickFFD" useSort>
      <template v-slot:rowButton="{ row }">
        <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/ffd/ffd_multi.png" draggable="false" />
        <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
      </template>
    </custom-table>
    <div class="w-100">
      <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
        {{ $t('individual.label_req05_warning') }}
      </div>
    </div>
    
  </div>

  <processing-view :processing="processing"></processing-view>
</div>